import {
  GET_WHD_STMT_SUCCESS, GET_WHD_STMT_REQUEST, GET_WHD_STMT_FAILURE, RESET_WHD_STMT_LIST,
  UPDATE_POOLED_RATES_REQUEST, UPDATE_POOLED_RATES_SUCCESS, UPDATE_POOLED_RATES_FAILURE,
  UPDATE_WHD_STMT_REQUEST, UPDATE_WHD_STMT_SUCCESS, UPDATE_WHD_STMT_FAILURE,
  UPDATE_WHD_STMT_ROW_REQUEST, UPDATE_WHD_STMT_ROW_SUCCESS, UPDATE_WHD_STMT_ROW_FAILURE,
  ADD_NEW_BO_REQUEST, ADD_NEW_BO_SUCCESS, ADD_NEW_BO_FAILURE, SAVE_WHD_COLLAPSED_TIERS,
  DELETE_WHD_STMT_ROW_REQUEST, DELETE_WHD_STMT_ROW_SUCCESS, DELETE_WHD_STMT_ROW_FAILURE,
  CHANGE_IMY_PARENT_ACCOUNT_REQUEST, CHANGE_IMY_PARENT_ACCOUNT_SUCCESS, CHANGE_IMY_PARENT_ACCOUNT_FAILURE,
  CHANGE_BO_PARENT_ACCOUNT_REQUEST, CHANGE_BO_PARENT_ACCOUNT_SUCCESS, CHANGE_BO_PARENT_ACCOUNT_FAILURE,
  SET_WHD_SCROLL_POSITION,
  PUBLISH_WHD_STMT_REQUEST, PUBLISH_WHD_STMT_SUCCESS, PUBLISH_WHD_STMT_FAILURE,
  OPEN_EFFECTIVE_DATE_CONFIRM_MODAL, CLOSE_EFFECTIVE_DATE_CONFIRM_MODAL, RESET_ACCOUNT_WHS_LINKING,
  GET_WHD_FORM_UPLOADS_REQUEST, GET_WHD_FORM_UPLOADS_SUCCESS, GET_WHD_FORM_UPLOADS_FAILURE,
  GET_WHD_BULK_UPLOADS_REQUEST, GET_WHD_BULK_UPLOADS_SUCCESS, GET_WHD_BULK_UPLOADS_FAILURE,
  TOGGLE_ADD_WHS_DOCUMENTS_MODAL, TOGGLE_IS_SUBMITTING_WHS_DOCUMENTS, TOGGLE_REASSIGN_WHS_DOCUMENT_MODAL,
  TOGGLE_UNDO_WHD_UPLOAD_MODAL, UNDO_WHD_UPLOAD_REQUEST, UNDO_WHD_UPLOAD_SUCCESS, UNDO_WHD_UPLOAD_FAILURE,
  GET_WHD_STMT_ZIP_EXPORT_STATUS_REQUEST, GET_WHD_STMT_ZIP_EXPORT_STATUS_SUCCESS, GET_WHD_STMT_ZIP_EXPORT_STATUS_FAILURE,
  GENERATE_WHD_STMT_ZIP_EXPORT_REQUEST, GENERATE_WHD_STMT_ZIP_EXPORT_SUCCESS, GENERATE_WHD_STMT_ZIP_EXPORT_FAILURE,
  CANCEL_WHD_STMT_ZIP_EXPORT_REQUEST, CANCEL_WHD_STMT_ZIP_EXPORT_SUCCESS, CANCEL_WHD_STMT_ZIP_EXPORT_FAILURE,
  DOWNLOAD_WHD_STMT_ZIP_EXPORT_REQUEST, DOWNLOAD_WHD_STMT_ZIP_EXPORT_SUCCESS, DOWNLOAD_WHD_STMT_ZIP_EXPORT_FAILURE
} from 'actions';

function getOwners(recipient, level, structureLocator, index, parents, parentIdentifier) {
  const structureLocation = (structureLocator && `${ structureLocator }-${ index }`) || `${ index }`;
  const accountId = (recipient.basicDetails && recipient.basicDetails.accountId) || recipient.accountId;
  const name = (recipient.ownerDetails && recipient.ownerDetails.name) || ((recipient.basicDetails && recipient.basicDetails.name) ?? recipient.accountName);
  const guid = (recipient.ownerDetails && recipient.ownerDetails.guid) || recipient.guid || '';
  const owners = [{ level, structureLocation, accountId, name, guid, parents, isIMY: Array.isArray(recipient.recipients), parentIdentifier: parentIdentifier ?? null }];
  const items = recipient.recipients && recipient.recipients
    .map((item, idx) => getOwners(item, level + 1, structureLocation, idx, [...parents, name], guid || name));

  if (items && items.length > 0) {
    return items.reduce((p, c) => {
      if (!c) {
        return p;
      }

      if (Array.isArray(c)) {
        return [...p, ...c];
      }

      return [...p, c];
    }, owners);
  }

  return owners;
}

function deriveStatementOwners(structure) {
  if (structure === null) {
    return null;
  }

  if (!structure) {
    return [];
  }

  return getOwners(structure, 0, null, 0, []);
}

// eslint-disable-next-line default-param-last
function withholdingStatement(state = {
  accountId: null,
  isGettingStatement: false,
  isStructureValid: false,
  beneficiaryList: null,
  statement: null,
  structure: null,
  isSavingStatement: false,
  isSaveFailed: false,
  isUpdatingStatement: false,
  statementPosition: {},
  tierCollapseStructure: null,
  validationResult: null,
  isDeletingRow: false,
  isShowingEffectiveDateConfirmation: false,
  isPublishingStatement: false,
  zipExportStatus: null,
  isGettingZipExportStatus: false,
  isGeneratingZipExport: false,
  isDownloadingZipExport: false,
  topAccount: null,
  isWhsLinkingActive: false
}, action) {
  const { accountId } = state;
  const actionAccountId = action.accountId && Array.isArray(accountId) && accountId.length > 0 ? accountId[0] : accountId;

  switch (action.type) {
    case CHANGE_IMY_PARENT_ACCOUNT_REQUEST:
      return {
        ...state,
        isUpdatingStatement: true,
        accountId: action.accountId,
        changeDetails: action.statement
      };
    case CHANGE_IMY_PARENT_ACCOUNT_SUCCESS:
      return {
        ...state,
        isUpdatingStatement: false,
        accountId: (actionAccountId && parseInt(actionAccountId, 10)) || null,
        statement: action.statementContainer.statement
          ? { ...action.statementContainer.statement, isPublishedFallback: action.statementContainer.isPublishedFallback }
          : null,
        structure: action.statementContainer.structure,
        topAccount: action.statementContainer.topAccount
      };
    case CHANGE_IMY_PARENT_ACCOUNT_FAILURE:
      return {
        ...state,
        isUpdatingStatement: false,
        accountId: action.accountId
      };
    case CHANGE_BO_PARENT_ACCOUNT_REQUEST:
      return {
        ...state,
        isUpdatingStatement: true,
        accountId: action.accountId,
        changeDetails: action.statement
      };
    case CHANGE_BO_PARENT_ACCOUNT_SUCCESS:
      return {
        ...state,
        isUpdatingStatement: false,
        accountId: (actionAccountId && parseInt(actionAccountId, 10)) || null,
        statement: action.statementContainer.statement
          ? { ...action.statementContainer.statement, isPublishedFallback: action.statementContainer.isPublishedFallback }
          : null,
        structure: action.statementContainer.structure,
        topAccount: action.statementContainer.topAccount
      };
    case CHANGE_BO_PARENT_ACCOUNT_FAILURE:
      return {
        ...state,
        isUpdatingStatement: false,
        accountId: action.accountId
      };
    case GET_WHD_STMT_REQUEST:
      return {
        ...state,
        isGettingStatement: true,
        accountId: action.accountId,
        statement: action.statement,
        zipExportStatus: null,
        isGettingZipExportStatus: false,
        isGeneratingZipExport: false,
        isDownloadingZipExport: false
      };
    case GET_WHD_STMT_SUCCESS:
      return {
        ...state,
        isGettingStatement: false,
        isStructureValid: action.statementContainer.isStructureValid,
        accountId: (actionAccountId && parseInt(actionAccountId, 10)) || null,
        beneficiaryList: (action.statementContainer && deriveStatementOwners(action.statementContainer.structure)) || null,
        statement: action.statementContainer.statement
          ? { ...action.statementContainer.statement, isPublishedFallback: action.statementContainer.isPublishedFallback }
          : null,
        structure: action.statementContainer.structure,
        validationResult: action.statementContainer.validationResult,
        topAccount: { ...action.statementContainer.topAccount, isWhsLinkingActive: action.statementContainer.isWhsLinkingActive },
        versionWindows: action.statementContainer.versionWindows
      };
    case GET_WHD_STMT_FAILURE:
      return {
        ...state,
        isGettingStatement: false,
        accountId: action.accountId,
        zipExportStatus: null,
        isGettingZipExportStatus: false,
        isGeneratingZipExport: false,
        isDownloadingZipExport: false
      };
    case RESET_WHD_STMT_LIST:
      return {
        ...state,
        accountId: null,
        statement: null,
        structure: null,
        zipExportStatus: null,
        isGettingZipExportStatus: false,
        isGeneratingZipExport: false,
        isDownloadingZipExport: false,
        topAccount: null
      };
    case SET_WHD_SCROLL_POSITION:
      // eslint-disable-next-line no-case-declarations
      const statementPositionList = state.statementPosition;
      statementPositionList[action.accountId] = action.scrollPosition;

      return {
        ...state,
        statementPosition: statementPositionList
      };
    case ADD_NEW_BO_REQUEST:
      return {
        ...state,
        isAddingNewBeneficalOwner: true,
      };
    case ADD_NEW_BO_SUCCESS:
      return {
        ...state,
        isAddingNewBeneficalOwner: false,
        statement: action.statementContainer.statement
          ? { ...action.statementContainer.statement, isPublishedFallback: action.statementContainer.isPublishedFallback }
          : null,
        structure: action.statementContainer.structure,
        validationResult: action.statementContainer.validationResult || state.validationResult,
        beneficiaryList: (action.statementContainer && deriveStatementOwners(action.statementContainer.structure)) || null,
        topAccount: action.statementContainer.topAccount
      };
    case ADD_NEW_BO_FAILURE:
      return {
        ...state,
        isAddingNewBeneficalOwner: false,
      };
    case UPDATE_POOLED_RATES_REQUEST:
      return {
        ...state,
      };
    case UPDATE_POOLED_RATES_SUCCESS:
      return {
        ...state,
        structure: action.structure,
        validationResult: action.validationResult,
        topAccount: action.topAccount
      };
    case UPDATE_POOLED_RATES_FAILURE:
      return {
        ...state,
      };
    case SAVE_WHD_COLLAPSED_TIERS:
      return {
        ...state,
        tierCollapseStructure: action.tiersObject
      };
    case UPDATE_WHD_STMT_REQUEST:
      return {
        ...state,
        isSavingStatement: true
      };
    case UPDATE_WHD_STMT_SUCCESS:
      return {
        ...state,
        statement: action.statement,
        structure: action.structure,
        validationResult: action.validationResult,
        isSavingStatement: false,
        topAccount: action.topAccount
      };
    case UPDATE_WHD_STMT_FAILURE:
      return {
        ...state,
        isSavingStatement: false
      };
    case UPDATE_WHD_STMT_ROW_SUCCESS:
      return {
        ...state,
        isSavingStatement: false,
        isStructureValid: action.isStructureValid,
        structure: action.structure,
        statement: action.statement,
        validationResult: action.validationResult || state.validationResult,
        beneficiaryList: (action.structure && deriveStatementOwners(action.structure)) || null,
        topAccount: action.topAccount
      };
    case UPDATE_WHD_STMT_ROW_REQUEST:
      return {
        ...state,
        isSavingStatement: true
      };
    case UPDATE_WHD_STMT_ROW_FAILURE:
      return {
        ...state,
        isSavingStatement: false
      };
    case DELETE_WHD_STMT_ROW_REQUEST:
      return {
        ...state,
        isDeletingRow: true
      };
    case DELETE_WHD_STMT_ROW_SUCCESS:
      return {
        ...state,
        isStructureValid: action.isStructureValid,
        structure: action.structure,
        statement: action.statement,
        validationResult: action.validationResult || state.validationResult,
        beneficiaryList: (action.structure && deriveStatementOwners(action.structure)) || null,
        isDeletingRow: false,
        topAccount: action.topAccount
      };
    case DELETE_WHD_STMT_ROW_FAILURE:
      return {
        ...state,
        isDeletingRow: false
      };
    case PUBLISH_WHD_STMT_REQUEST:
      return {
        ...state,
        isSavingStatement: true,
        isPublishingStatement: true
      };
    case PUBLISH_WHD_STMT_SUCCESS:
      state.statement.effectiveDate = action.effectiveDate;
      state.statement.effectiveTo = action.effectiveToDate;

      return {
        ...state,
        isSavingStatement: false,
        isPublishingStatement: false
      };
    case PUBLISH_WHD_STMT_FAILURE:
      return {
        ...state,
        isSavingStatement: false,
        isPublishingStatement: false
      };
    case GET_WHD_STMT_ZIP_EXPORT_STATUS_REQUEST:
      return {
        ...state,
        isGettingZipExportStatus: action.isGettingZipExportStatus
      };
    case GET_WHD_STMT_ZIP_EXPORT_STATUS_SUCCESS:
      return {
        ...state,
        isGettingZipExportStatus: action.isGettingZipExportStatus,
        zipExportStatus: action.zipExportResponse.status,
        zipFailedExportFiles: action.zipExportResponse.failedFiles
      };
    case GET_WHD_STMT_ZIP_EXPORT_STATUS_FAILURE:
      return {
        ...state,
        isGettingZipExportStatus: action.isGettingZipExportStatus
      };
    case GENERATE_WHD_STMT_ZIP_EXPORT_REQUEST:
      return {
        ...state,
        isGeneratingZipExport: action.isGeneratingZipExport
      };
    case GENERATE_WHD_STMT_ZIP_EXPORT_SUCCESS:
      return {
        ...state,
        isGeneratingZipExport: action.isGeneratingZipExport,
        zipExportStatus: action.zipExportStatus
      };
    case GENERATE_WHD_STMT_ZIP_EXPORT_FAILURE:
      return {
        ...state,
        isGeneratingZipExport: action.isGeneratingZipExport
      };
    case CANCEL_WHD_STMT_ZIP_EXPORT_REQUEST:
      return {
        ...state,
        isGeneratingZipExport: action.isGeneratingZipExport
      };
    case CANCEL_WHD_STMT_ZIP_EXPORT_SUCCESS:
      return {
        ...state,
        isGeneratingZipExport: action.isGeneratingZipExport,
        zipExportStatus: action.zipExportStatus
      };
    case CANCEL_WHD_STMT_ZIP_EXPORT_FAILURE:
      return {
        ...state,
        isGeneratingZipExport: action.isGeneratingZipExport
      };
    case DOWNLOAD_WHD_STMT_ZIP_EXPORT_REQUEST:
      return {
        ...state,
        isDownloadingZipExport: action.isDownloadingZipExport
      };
    case DOWNLOAD_WHD_STMT_ZIP_EXPORT_SUCCESS:
      return {
        ...state,
        isDownloadingZipExport: action.isDownloadingZipExport
      };
    case DOWNLOAD_WHD_STMT_ZIP_EXPORT_FAILURE:
      return {
        ...state,
        isDownloadingZipExport: action.isDownloadingZipExport
      };
    case OPEN_EFFECTIVE_DATE_CONFIRM_MODAL:
      return {
        ...state,
        isShowingEffectiveDateConfirmation: true
      };
    case CLOSE_EFFECTIVE_DATE_CONFIRM_MODAL:
      return {
        ...state,
        isShowingEffectiveDateConfirmation: false
      };
    case RESET_ACCOUNT_WHS_LINKING:
      return {
        ...state,
        topAccount: {
          ...state.topAccount,
          isWhsLinkingActive: action.isWhsLinkingActive
        }
      };
    case GET_WHD_FORM_UPLOADS_REQUEST:
      return {
        ...state,
        isGettingForms: true
      };
    case GET_WHD_FORM_UPLOADS_SUCCESS:
      return {
        ...state,
        isGettingForms: false,
        forms: action.forms,
        formsCount: action.formsCount,
      };
    case GET_WHD_FORM_UPLOADS_FAILURE:
      return {
        ...state,
        isGettingForms: false
      };
    case GET_WHD_BULK_UPLOADS_REQUEST:
      return {
        ...state,
        isGettingBulkUploads: true
      };
    case GET_WHD_BULK_UPLOADS_SUCCESS:
      return {
        ...state,
        isGettingBulkUploads: false,
        bulkUploads: action.bulkUploads,
        bulkUploadCount: action.bulkUploadCount,
      };
    case GET_WHD_BULK_UPLOADS_FAILURE:
      return {
        ...state,
        isGettingBulkUploads: false
      };
    case TOGGLE_ADD_WHS_DOCUMENTS_MODAL:
      return {
        ...state,
        isAddWhsDocumentsModalShown: action.isAddWhsDocumentsModalShown,
      };
    case TOGGLE_IS_SUBMITTING_WHS_DOCUMENTS:
      return {
        ...state,
        isSubmittingAddWhsDocuments: action.isSubmittingAddWhsDocuments
      };
    case TOGGLE_REASSIGN_WHS_DOCUMENT_MODAL:
      return {
        ...state,
        isReassignWhsDocumentModalShown: action.isReassignWhsDocumentModalShown,
        reassignWhsDocumentFormId: action.reassignWhsDocumentFormId,
        reassignWhsDocumentFormOriginalFileName: action.reassignWhsDocumentFormOriginalFileName
      };
    case TOGGLE_UNDO_WHD_UPLOAD_MODAL:
      return {
        ...state,
        isUndoWhdUploadModalShown: action.isUndoWhdUploadModalShown,
        undoWhdUploadId: action.undoWhdUploadId,
        undoWhdUploadOriginalFileName: action.undoWhdUploadOriginalFileName
      };
    case UNDO_WHD_UPLOAD_REQUEST:
      return {
        ...state,
        isUndoingWhdUpload: true
      };
    case UNDO_WHD_UPLOAD_SUCCESS:
      return {
        ...state,
        isUndoingWhdUpload: false
      };
    case UNDO_WHD_UPLOAD_FAILURE:
      return {
        ...state,
        isUndoingWhdUpload: false
      };
    default:
      return state;
  }
}

export default withholdingStatement;
